export const actionClick = (action: string, state: any) => ({
    type: 'ACTION_CLICK',
    payload: {
        action,
        state
    }
});



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/actions/project-actions/action-click.ts